import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'comunidades',
  initialState: {
    isLoading: false,
    entities: [],
    error: null,
    loadedEmpresaId: null,
  },
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoading = payload
      if (payload) state.error = null
    },
    setComunidadesData: (state, { payload }) => {
      state.entities = payload.data
      state.loadedEmpresaId = payload.empresaId
      state.isLoading = false
      state.error = null
    },
    setError: (state, { payload }) => {
      state.error = payload
      state.isLoading = false
    },
  },
})

export const comunidadesReducer = slice.reducer
export const { setLoading, setComunidadesData, setError } = slice.actions
